module.exports = __webpack_public_path__ + "img/win2.3483d7c8.png";